module.exports = __webpack_public_path__ + "static/img/can-blueberry-pomegranate.182aebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-blueberry-pomegranate.png
// module id = 8tra
// module chunks = 0